import { createFileRoute, redirect } from '@tanstack/react-router'
import { GrniReportScreen } from '@/features/purchasing-reports/grni-report'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute(
  '/_authenticated/purchasing/reports/goods-received-not-invoiced',
)({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'goods_receipt.view')) {
      throw redirect({ to: '/purchasing/receipts' })
    }
  },
  component: GoodsReceivedNotInvoicedRoute,
})

function GoodsReceivedNotInvoicedRoute() {
  return <GrniReportScreen />
}
